export default "__VITE_ASSET__e073ab68__"